import { useState } from 'react';
import { AcceptLinkRef, getAcceptLinkRef } from 'src/auth/utils/inviteStorage';

/**
 * The accept-link a self-resend would be issued against, on pages that hold no invite
 * details of their own.
 */
export const useInviteResendTarget = (): AcceptLinkRef | null => {
  const [storedRef] = useState(getAcceptLinkRef);
  return storedRef;
};
